import Reminder from './Reminder';
export default Reminder;
